import { CDX_SETTINGS_SITE_CONTENT_MODEL_ID } from '../globals/siteSettings.js';
import { getContentEntry } from './client.js';
const fetchSiteConfig = async queryOpts => {
  const entry = await getContentEntry({
    env: queryOpts.env,
    isPreview: queryOpts.isPreview,
    contentType: CDX_SETTINGS_SITE_CONTENT_MODEL_ID,
    locale: queryOpts.locale
  });
  return entry;
};
export { fetchSiteConfig };
//# sourceMappingURL=fetchSiteConfig.js.map
